import React from 'react';
import styles from '../layout/AdminLayout.module.css';

const MentorManagementComponent: React.FC = () => {
  return (
    <div className={styles.pageContainer}>
      <div>
        <b className={styles.pageTitle}>멘토 관리</b>
      </div>
      
      <div className={styles.pageContent}>
        <p>멘토 관리 기능을 구현해주세요.</p>
      </div>
    </div>
  );
};

export default MentorManagementComponent;
